export default function RegisterGAHit(pageTitle, page) {
    if (!page || page.length === 0) {
        page = getGAPage();
    }
    if (!pageTitle || pageTitle.length === 0)
        pageTitle = document.title;
    //DEV/QA
    //ga('create', 'UA-86038946-3', 'none');
    //prod
    ga('create', 'UA-84809210-8', 'none');
    ga('set', 'page', page);
    ga('set', 'title', pageTitle);
    ga('send', 'pageview');
}

export function getGAPage() {
    var url = window.location.toString();
    var newQueryString = "";
    var hash = "";
    newQueryString = removeTokenFromQueryString(location.search);
    if (window.location.hash.length > 0) {
        hash = url.substring(url.indexOf("#") + 1);
        if (url.indexOf("?") > -1) {
            hash = hash.split('?')[0] + removeTokenFromQueryString(hash.split('?')[1]);
        }
    }
    return window.location.pathname + hash.substring(1) + newQueryString;
}

export function removeTokenFromQueryString(queryString) {
    if (queryString && queryString.substring(0, 1) == "?")
        queryString = queryString.substring(1);
    var newQueryString = "";
    var params = (queryString && queryString.indexOf('&') > -1) ? queryString.substring(0).split('&') : "";
    if (params.length > 0) {
        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split('=');
            if (decodeURIComponent(pair[0]) != 't' && pair[1])
                //if ((pair[0] != 't' && pair[0] != '?t') && pair[1])
                newQueryString = newQueryString + (newQueryString.length > 0 ? "&" : "") + decodeURIComponent(pair[0]) + "=" + pair[1];
        }
    }
    if (newQueryString.length > 0) {
        newQueryString = "?" + newQueryString;
        //page = window.location.pathname + newQueryString;
    }
    return newQueryString;
}
